
export const isValidPhoneNumber = (phone) => {
  return /^\+\d{8,15}$/.test(phone);
};

export const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};